import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import { AddPost, Blog, BlogDiscardButton, BlogPostButton, PostEdit } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { FormPost } from "./FormPost";
import DropzoneClass from "./DropzoneClass";

const AddPostContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={AddPost} parent={Blog} title={AddPost} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={PostEdit} />
              <CardBody className="add-post">
                <FormPost />
                <DropzoneClass />
                <div className="btn-showcase text-end">
                  <Btn color="primary">{BlogPostButton}</Btn>
                  <Btn color="light" type="reset">{BlogDiscardButton}</Btn>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddPostContainer;
